import * as Sentry from '@sentry/nextjs';

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

Sentry.init({
  dsn: SENTRY_DSN || 'https://82cd5fb860cc4140a6d89b5dea6ce2a3@o951359.ingest.sentry.io/4504455812874240',
  tracesSampleRate: 0.2,
});
